module.exports = __webpack_public_path__ + "static/Gold_Dragon-a0b771b2788bf9d9ef6c7fb3b955891a.jpg";